import React from 'react';
import { WorkplaceWorkerItem } from './WorkplaceWorkersListItem';
// @ts-ignore
import styles from './WorkplaceWorkersListItemListView.module.scss';
import UserAvatarImage from '../../../../../../Components/UserAvatar/UserAvatarImage';
import WorkplaceWorkersItemStatusBadge from '../WorkplaceWorkersItemStatusBadge/WorkplaceWorkersItemStatusBadge';
import { WorkplaceWorkersStatus } from '../../../../Enums/WorkplaceWorkersStatus.enum';

interface Props {
	item: WorkplaceWorkerItem;
	onClick: () => void;
}

const WorkplaceWorkersListItemListView: React.FC<Props> = ({
	item,
	onClick,
}) => {
	return (
		<div className={styles.wrapper} onClick={onClick}>
			<div className={styles.leftSide}>
				<div className={styles.image}>
					<UserAvatarImage
						userId={item.id}
						profileImageUrl={item.profileImageUrl}
					/>
				</div>
				<div className={styles.content}>
					<div className={styles.name}>
						{item.profile?.fullName || item.email}
					</div>
				</div>
			</div>
			<div className={styles.rightSide}>
				<div className={styles.badgeWrapper}>
					<WorkplaceWorkersItemStatusBadge
						status={item.rootWorkplaceMemberStatus as WorkplaceWorkersStatus}
					/>
				</div>
			</div>
		</div>
	);
};

export default WorkplaceWorkersListItemListView;
